import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Global } from '../global';

export type InventoryAction = 'metrics' | 'load' | 'return-to-stock' | 'assign' | 'return' | 'query' | 'update';

export interface InventoryMetricsFilters {
  categoria_activo?: string | null;
  clase_activo?: string | null;
  marca?: string | null;
  estatus?: string | null;
  cliente_sucursal?: string | null;
  min_valor_renting?: string | null;
  max_valor_renting?: string | null;
}

export interface InventoryAssignPayload {
  placa_inventario: string;
  usuario: string;
  celular: string;
  direccion: string;
  observaciones?: string;
  area?: string;
  nombre_equipo?: string;
  hardware?: string;
  placa_inventario_cargador?: string;
  placa_seguridad_cargador?: string;
  sistema_operativo?: string;
  valor_comercial?: string;
  valor_poliza?: string;
}

export interface InventoryUpdatePayload {
  placa_inventario: string;
  celular?: string;
  direccion?: string;
  observaciones?: string;
  area?: string;
  nombre_equipo?: string;
  placa_inventario_cargador?: string;
  placa_seguridad_cargador?: string;
  valor_comercial?: string;
  valor_poliza?: string;
}

export interface InventoryQueryFilters {
  estatus?: string | null;
  placa?: string | null;
  usuario?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class InventarioService {
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient) {
    this.baseUrl = Global.url ? `${Global.url.replace(/\/$/, '')}/Inventory` : '/api/v1/Inventory';
  }

  uploadMetrics(file: File, filters?: InventoryMetricsFilters): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value != null && value !== '') {
          formData.append(key, value);
        }
      });
    }

    return this.postMultipart('/metrics', formData);
  }

  loadInventory(file: File, confirmLoad = true): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('confirm_load', String(confirmLoad));

    return this.postMultipart('/load', formData);
  }

  returnToStock(placaInventario: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/return-to-stock`, {
      placa_inventario: placaInventario
    }, { headers: this.buildHeaders() });
  }

  assignEquipment(payload: InventoryAssignPayload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/assign`, payload, { headers: this.buildHeaders() });
  }

  updateInventoryFields(payload: InventoryUpdatePayload): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/update`, payload, { headers: this.buildHeaders() });
  }

  returnEquipment(placaInventario: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/return`, {
      placa_inventario: placaInventario
    }, { headers: this.buildHeaders() });
  }

  queryInventory(filters: InventoryQueryFilters): Observable<any> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value != null && value !== '') {
        params.set(key, value);
      }
    });

    const queryString = params.toString();
    const url = queryString ? `${this.baseUrl}/query?${queryString}` : `${this.baseUrl}/query`;

    return this.http.get<any>(url, { headers: this.buildHeaders() });
  }

  private postMultipart(path: string, formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}${path}`, formData, { headers: this.buildHeaders() });
  }

  private buildHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken');
    return new HttpHeaders({
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    });
  }
}